// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8wITX","delete":"styles_delete__3qZRR","update":"styles_update__yMCw9","add":"styles_add__3BGnK"};